import FooterLink from "./link"

function Footer(){
    const scrollToTop = () => {
        window.scrollTo(0, 0)
    }

    return(
        <footer className="h-[480px] md:h-[320px] bg-black text-white flex flex-col align-center justify-between text-left px-[18px] md:px-[24px] py-[24px] md:py-[48px]">
            <div className="flex flex-col lg:flex-row justify-start items-start lg:items-center lg:justify-between gap-[32px] md:gap-[40px] lg:gap-[160px]">
                <img className="h-[32px] xl:h-[52px]" src={"/icons/hmt-logo-white-full.svg"}></img>
                <div className="flex flex-col md:flex-row justify-between items-start w-full mx-[0px] lg:mx-[64px] group gap-[16px] lg:gap-[0px]">
                    <div>
                        <FooterLink onClick={scrollToTop} footer_id={1}></FooterLink>
                    </div>
                    <div className="hidden lg:flex flex-col gap-[28px] lg:gap-[32px]">
                        <FooterLink onClick={scrollToTop} footer_id={2}></FooterLink>
                        <FooterLink onClick={scrollToTop} footer_id={3}></FooterLink>
                    </div>
                    <div className="block lg:hidden">
                        <FooterLink onClick={scrollToTop} footer_id={2}></FooterLink>
                    </div>
                    <div className="block lg:hidden">
                        <FooterLink onClick={scrollToTop} footer_id={3}></FooterLink>
                    </div>
                    <div>
                        <FooterLink onClick={scrollToTop} footer_id={4}></FooterLink>
                    </div>
                </div>
            </div>
            <p className="text-[12px] font-light">© 2026 Harmoni Mitra Tekno</p>
        </footer>
    )
}

export default Footer